import styles from './Value.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface ValueArrayDetail {
  imgSrc: string
  title: string
  text: string
}

export interface ValueItem {
  sectionTitle: string
  sectionRead: string | JSX.Element
  valueTitle: string
  valueArray: ValueArrayDetail[]
}

interface Props {
  ValueEach: ValueItem[]
}

const Value: React.FC<Props> = ({ ValueEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.value} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>{ValueEach[0].sectionTitle}</h2>
      <p className={styles.sectionRead}>{ValueEach[0].sectionRead}</p>
      <h3 className={styles.valueTitle}>{ValueEach[0].valueTitle}</h3>
      <div className={styles.wrapper}>
        {ValueEach[0].valueArray.map((item, idx) => (
          <section className={styles.valueItem} key={idx}>
            <figure className={styles.valueItem__image}>
              <img src={item.imgSrc} alt={item.title} width={48} height={48} />
            </figure>
            <h4 className={styles.valueItem__title}>{item.title}</h4>
            <p className={styles.valueItem__text}>{item.text}</p>
          </section>
        ))}
      </div>
    </section>
  )
}

export default Value
